import { useState, useMemo } from 'react';
import AppLayout from '@amzn/awsui-components-console/app-layout';
import BreadcrumbGroup from '@amzn/awsui-components-console/breadcrumb-group';
import SideNav from '../components/navigation/SideNav';
import AppRouter from './AppRouter';
import { useLocation } from 'react-router';
import {
  useNavState,
  getBreadcrumbItems,
} from '../components/navigation/context';
import { useAuthState } from '../authentication/context';
import { isDevDesk } from '../ConferencePages/conferenceInfo/utils';
import { AppTopNavigation } from './AppTopNavigation';

export default function App() {
  const [navigationOpen, setNavigationOpen] = useState(true);
  const { breadcrumbNameOverrides } = useNavState();
  const { isAuthenticated } = useAuthState();
  const location = useLocation();

  // Derive the breadcrumb trail directly from the current location on every
  // render, rather than pushing it into state via a navigation event. Because it
  // is a pure function of the path (+ known label overrides), it reconstructs
  // correctly on a browser refresh of any deep page — fixing breadcrumbs
  // disappearing after a reload (they previously depended on a navigation event
  // that never re-fired once auth resolved post-refresh). Keyed on
  // isAuthenticated so the trail (hidden until authenticated) appears as soon as
  // auth resolves after a reload.
  const breadcrumbTrail = useMemo(
    () =>
      isAuthenticated || isDevDesk()
        ? getBreadcrumbItems(location.pathname, breadcrumbNameOverrides)
        : [],
    [isAuthenticated, location.pathname, breadcrumbNameOverrides]
  );

  if (window.location.hash !== '#/' && window.location.hash !== '') {
    sessionStorage.setItem('startingUrlHash', window.location.hash);
  }

  return (
    <>
      <AppTopNavigation />
      <AppLayout
        content={<AppRouter />}
        contentType='default'
        navigation={<SideNav />}
        breadcrumbs={<BreadcrumbGroup items={breadcrumbTrail} />}
        toolsHide
        navigationOpen={navigationOpen}
        onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      />
    </>
  );
}
